// extracted by mini-css-extract-plugin
module.exports = {"blocked":"m_d","loader":"m_f","parallax":"m_N","parallax__img":"m_P","parallax__inner":"m_Q"};